import React from "react";
import "./Radio.scss";


function Radio({ children, value, name, defaultChecked, disabled }) {
    return (
        <div className="radio-group">
            <label className={`radio-button`}>
                <input
                    type="radio"
                    value={value}
                    name={name}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                />
                {children}
            </label>
        </div>
    );
}


export default Radio;